document.addEventListener("DOMContentLoaded", function () {
  const searchForm = document.getElementById("header-search-form-main");
  const searchInput = document.getElementById("header-search-input");
  const searchContainer = document.querySelector(".search-container");
  const searchFormWrapper = document.getElementById(
    "header-search-form-wrapper"
  );

  if (searchForm && searchInput && searchContainer) {
    // Focus on hover
    searchContainer.addEventListener("mouseenter", function () {
      setTimeout(function () {
        searchInput.focus();
      }, 500); // Adjust the delay to match your CSS transition duration
    });

    // Close search when mouse leaves the search container
    searchContainer.addEventListener("mouseleave", function () {
      if (searchFormWrapper && typeof searchFormWrapper.close === "function") {
        searchFormWrapper.close();
      } else {
        // Fallback if custom element methods aren't available
        document.body.classList.remove("open-search");
        const predictiveSearch = document.querySelector(
          ".thb-predictive-search"
        );
        if (predictiveSearch) {
          predictiveSearch.setAttribute("inert", "");
        }
      }
    });
  }
});
